<div class="modal-content">

  <h5 mat-dialog-title [innerHTML]="paragraphUtil.getTranslation('household_message', data.houseHoldId )"></h5>

  <!--<h5 mat-dialog-title *ngIf="data.needREDCap" [innerHTML]="paragraphUtil.getTranslation('survey_guideline_link' )"></h5>-->

  <div class="button">
    <button mat-flat-button color="primary" (click)="onConfirm()">
      {{ "Continue" | translate }}
    </button>
  </div>
</div>


<form ngNoForm  [action]="'https://unmcredcap.unmc.edu/redcap/surveys/?s=LCNYL73XFA'" target="_blank" method="post" [hidden]="true">
  <div *ngFor="let survey of surveys | slice:0:10 ;  let i = index ">
    <input type="hidden" name="district_name{{ i + 1}}" value="{{ getDistrictNameById(survey.institutionId) }}">
    <input type="hidden" name="school_name{{ i + 1}}" value="{{ getSchoolNameById(survey.institutionId, survey.facilityId) }}">
    <input type="hidden" name="grade{{ i + 1}}" value="{{ getGradeNameById(survey.institutionId, survey.facilityId, survey.unitId) }}">
  </div>
  <input *ngIf="surveys[0]" type="hidden" name="household_id" value="{{ surveys[0].houseHoldId }}">
  <button #REDCapButton type="submit" name="__prefill"  value="__prefill"  [hidden]="true">Pre-fill Survey</button>
</form>
